module.exports = "<div class=\"envelope\">\r\n    <div *ngIf=\"isAuthenticated\">\r\n        <div class=\"form-group envelope__title\">\r\n            <h1>Authenticated</h1>\r\n            <h2>User claims</h2>\r\n        </div>\r\n\r\n        <dl class=\"\">\r\n            <div *ngFor=\"let claim of userInfo.claims\">\r\n                <dt>{{claim.name}}</dt>\r\n                <dd>{{claim.value}}</dd>\r\n            </div>\r\n        </dl>\r\n    </div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/templates/account/accountView.component.html
// module id = 449
// module chunks = 0